import './hero-page.scss';

const heroPage = () => {
	(function () {
	    var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
	    document.querySelectorAll(".hero-bg-video").forEach(function (video) {
	        if (reducedMotion) { video.removeAttribute("autoplay"); video.pause(); return; }
	        if ("IntersectionObserver" in window) {
	            var obs = new IntersectionObserver(function (entries) {
	                entries.forEach(function (e) {
	                    if (e.isIntersecting) { video.play().catch(function(){}); } else { video.pause(); }
	                });
	            }, { threshold: 0.1 });
	            var sec = video.closest(".hero-section");
	            if (sec) { obs.observe(sec); }
	        }
	    });
	    document.querySelectorAll(".hero-bg-iframe-wrap").forEach(function (wrap) {
	        wrap.style.pointerEvents = "none";
	        if (reducedMotion) {
	            var sec = wrap.closest(".hero-section");
	            if (sec && sec.style.backgroundImage && sec.style.backgroundImage !== "none") { wrap.remove(); }
	        }
	    });
	}());
};

export default heroPage;